import { ReactNode, Suspense } from 'react';

// Perfect Scrollbar
import 'react-perfect-scrollbar/dist/css/styles.css';

//DataTable css
import '@mantine/core/styles.layer.css';
import 'mantine-contextmenu/styles.layer.css';
import 'mantine-datatable/styles.layer.css';

//Flatpickr css
import 'flatpickr/dist/flatpickr.css';

//React Quill css
import 'react-quill/dist/quill.snow.css';

// React Suite css
import 'rsuite/dist/rsuite-no-reset.min.css';

// Tailwind css
import '../tailwind.css';

// i18n (needs to be bundled)
import '../i18n';

//React Toastify css
import 'react-toastify/dist/ReactToastify.css';

//Fortawesome css
import '@fortawesome/fontawesome-svg-core/styles.css';

// React Suite css
import 'rsuite/dist/rsuite-no-reset.min.css';

//react Tippy
import 'tippy.js/dist/tippy.css';

//Custom css
import { ToastContainer } from 'react-toastify';
import '../Assets/css/appStyle.css';
import '../Assets/css/styleG.css';
import { MainLoader } from '../Components/Common';

const StylesWrapper = ({ children }: { children: ReactNode }) => {
  return (
    <Suspense fallback={<MainLoader />}>
      {children}
      <ToastContainer />
    </Suspense>
  );
};

export default StylesWrapper;
